import { founder } from '../../data/content'
import { addDays, iso, startOfWeek } from '../../core/format/dates'
import type { SocialIdea, SocialPost } from '../../core/types/social'

/**
 * Startinhoud van de social planner, rond de huidige week. Het beheer begint
 * hiermee zolang er niets is opgeslagen; met een backend komt dit uit
 * GET /admin/content (AdminContent.marketing).
 */

const day = (offset: number) => iso(addDays(startOfWeek(new Date()), offset))

const tags = {
  base: ['#beautybewust', '#huidspecialist'],
  kennis: ['#huidkennis', '#skincaretips', '#gezondehuid'],
  medik8: ['#medik8', '#vitaminec', '#retinal'],
}

export const socialPosts: SocialPost[] = [
  {
    id: 'post-lancering',
    title: 'Lancering nieuwe website',
    date: day(-3),
    time: '19:30',
    platforms: ['Instagram-post', 'Facebook'],
    pillar: 'aanbod',
    status: 'geplaatst',
    designId: 'lancering-post',
    image: '',
    caption:
      'Na maanden schaven staat hij online: de nieuwe Beauty Bewust.\n\nMinder potjes, meer uitleg. Je vindt er per huidthema wat ik zelf zou kiezen, protocollen die samenwerken en een huidadvies van één minuut.\n\nKijk rond via de link in mijn bio — en laat me weten wat je ervan vindt.',
    hashtags: [...tags.base, '#nieuw'],
    firstComment: '',
    link: '',
    consent: false,
    notes: '',
  },
  {
    id: 'post-lancering-story',
    title: 'Story: website is live',
    date: day(-2),
    time: '08:00',
    platforms: ['Instagram-story', 'WhatsApp-status'],
    pillar: 'aanbod',
    status: 'geplaatst',
    designId: 'lancering-story',
    image: '',
    caption: 'De nieuwe website staat online. Kijk je even mee?',
    hashtags: [],
    firstComment: '',
    link: 'https://beautybewust.nl',
    consent: false,
    notes: '',
  },
  {
    id: 'post-spf',
    title: 'SPF in de winter? Ja.',
    // Altijd vandaag, zodat het overzicht laat zien hoe "vandaag posten" werkt.
    date: iso(new Date()),
    time: '19:30',
    platforms: ['Instagram-post', 'Facebook'],
    pillar: 'kennis',
    status: 'klaar',
    designId: 'tip-spf',
    image: '',
    caption:
      'De vraag die ik deze maand het vaakst krijg: “Moet ik nu echt nog SPF smeren?”\n\nJa. UVA — de straling die pigment en huidveroudering geeft — is in oktober bijna net zo sterk als in de zomer, en gaat gewoon door de wolken heen.\n\nWerk je met vitamine C of retinal? Dan is SPF geen extraatje maar een voorwaarde.',
    hashtags: [...tags.base, ...tags.kennis, '#spf'],
    firstComment: '',
    link: '',
    consent: false,
    notes: 'Dinsdagavond werkt het best voor huidtips.',
  },
  {
    id: 'post-ochtend',
    title: 'Achter de schermen: ochtend in de salon',
    date: day(3),
    time: '08:15',
    platforms: ['Instagram-story', 'WhatsApp-status'],
    pillar: 'achter',
    status: 'concept',
    image: founder.atWork,
    caption: 'Eerste cliënt om negen uur. Eerst de kamer warm, de olie klaar en een kop thee.',
    hashtags: [],
    firstComment: '',
    link: '',
    consent: false,
    notes: 'Drie korte fragmenten filmen: thee, handen, behandelbed.',
  },
  {
    id: 'post-minder',
    title: 'Citaat: minder potjes',
    date: day(6),
    time: '10:00',
    platforms: ['Instagram-post'],
    pillar: 'kennis',
    status: 'concept',
    designId: 'citaat-minder',
    image: '',
    caption:
      'Meestal haal ik bij een eerste consult eerst iets wég.\n\nEen huid die te veel krijgt, gaat reageren: roodheid, onzuiverheid, trekkerigheid. Vaak is de oplossing een kortere routine, niet een nieuwe aankoop.\n\nWat staat er op jouw badkamerplank?',
    hashtags: [...tags.base, '#minderismeer', '#huidfilosofie'],
    firstComment: '',
    link: '',
    consent: false,
    notes: '',
  },
  {
    id: 'post-ctetra',
    title: 'Medik8 C-Tetra uitgelicht',
    date: day(8),
    time: '19:30',
    platforms: ['Instagram-post', 'Facebook'],
    pillar: 'product',
    status: 'concept',
    designId: 'product-ctetra',
    image: '',
    caption:
      'Als ik één vitamine C mocht kiezen voor een beginner, is het deze.\n\nC-Tetra is een olie-oplosbare vorm: zacht voor een gevoelige huid, en toch zichtbaar in egaliteit na een week of vier.\n\n’s Ochtends, na je toner, altijd met SPF erna.',
    hashtags: [...tags.base, ...tags.medik8],
    firstComment: '',
    link: '',
    consent: false,
    notes: '',
  },
  {
    id: 'post-pigment',
    title: 'Pigmentprotocol in de kou',
    date: day(10),
    time: '20:30',
    platforms: ['Instagram-post'],
    pillar: 'aanbod',
    status: 'idee',
    designId: 'protocol-pigment',
    image: '',
    caption: '',
    hashtags: [...tags.base, '#pigmentatie'],
    firstComment: '',
    link: '',
    consent: false,
    notes: 'Herfst = beste moment om aan pigment te werken. Uitleggen waarom.',
  },
  {
    id: 'post-resultaat',
    title: 'Zes weken pigmentprotocol — M.',
    date: day(12),
    time: '19:30',
    platforms: ['Instagram-post'],
    pillar: 'resultaat',
    status: 'idee',
    image: '',
    caption: '',
    hashtags: [],
    firstComment: '',
    link: '',
    consent: false,
    notes: 'Vragen of M. akkoord is met voor/na, zonder gezicht of met.',
  },
]

export const socialIdeas: SocialIdea[] = [
  { id: 'idee-plank', text: 'Mijn eigen badkamerplank in 60 seconden', pillar: 'achter' },
  { id: 'idee-oktober', text: 'Waarom je huid in oktober ineens trekt', pillar: 'kennis' },
  { id: 'idee-retinal', text: 'Retinal of retinol: het verschil in één beeld', pillar: 'kennis' },
  { id: 'idee-combineren', text: 'Vraag van een cliënt: mag ik vitamine C en retinal combineren?', pillar: 'kennis' },
  { id: 'idee-olie', text: 'Welke olie ik gebruik bij bindweefselmassage, en waarom', pillar: 'achter' },
  { id: 'idee-sint', text: 'Cadeaubon voor Sinterklaas en de feestdagen', pillar: 'aanbod' },
]
